var path = 'app/scripts/modules/azure/securityGroup/configure/editSecurityGroup.html';
var html = "\n<v2-modal-wizard heading=\"Edit {{securityGroup.name}}: {{securityGroup.region}}: {{securityGroup.credentials}}\">\n  <v2-wizard-page key=\"Ingress\" label=\"Ingress\" done=\"true\">\n    <ng-include src=\"pages.ingress\"></ng-include>\n  </v2-wizard-page>\n</v2-modal-wizard>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/azure/securityGroup/configure/editSecurityGroup.html
// module id = 1680
// module chunks = 0